import React, { useEffect } from 'react'
import { Button } from 'components/UIElements'
import STRINGS from 'utils/strings'
import { MAX_PHOTO_LIMIT_MIN_VALUE, MAX_PHOTO_LIMIT_MAX_VALUE } from 'utils/constants'
import useInstrumentUnificationFeature from 'utils/hooks/useInstrumentUnificationFeature'

const MaxPhotoLimitPanel = ({ maxPhotoLimit, onPlusClick, onMinusClick, onSetDefaultValue, study, userId }) => {
  const { hasInstrumentUnification } = useInstrumentUnificationFeature({ study, userId })

  useEffect(() => {
    if (!maxPhotoLimit) {
      onSetDefaultValue()
    }
  }, [maxPhotoLimit])

  return hasInstrumentUnification ? (
    <div className='max-photo-limit attribute panel'>
      <h5 className='label-small med-font'>{STRINGS.maximumPhotoLimit}</h5>
      <div className='max-photo-limit-choices'>
        <Button
          className='inline flexed'
          onClick={onMinusClick}
          circle
          disabled={maxPhotoLimit <= MAX_PHOTO_LIMIT_MIN_VALUE}
          id='minus-options'
          icon='fas fa-minus'
        />
        <p className='inline flexed'>{maxPhotoLimit}</p>
        <Button
          className='inline flexed'
          onClick={onPlusClick}
          circle
          disabled={maxPhotoLimit >= MAX_PHOTO_LIMIT_MAX_VALUE}
          id='plus-options'
          icon='fas fa-plus'
        />
      </div>
    </div>
  ) : null
}

export default MaxPhotoLimitPanel
